/**
 * perfStats — Pure frame/tick sample math for agent perf harness.
 */

export function percentile(sortedAsc, p) {
  if (!sortedAsc.length) return 0;
  const clamped = Math.max(0, Math.min(100, p));
  const idx = Math.ceil((clamped / 100) * sortedAsc.length) - 1;
  return sortedAsc[Math.max(0, idx)];
}

export function fpsFromMeanFrameMs(meanMs) {
  if (!(meanMs > 0)) return 0;
  return 1000 / meanMs;
}

export function summarizeFrameSamples(frameMsSamples) {
  const samples = Array.isArray(frameMsSamples) ? frameMsSamples : [];
  if (!samples.length) {
    return { count: 0, meanMs: 0, p50Ms: 0, p95Ms: 0, fps: 0 };
  }
  const sorted = [...samples].sort((a, b) => a - b);
  const sum = sorted.reduce((acc, v) => acc + v, 0);
  const meanMs = sum / sorted.length;
  return {
    count: sorted.length,
    meanMs,
    p50Ms: percentile(sorted, 50),
    p95Ms: percentile(sorted, 95),
    fps: fpsFromMeanFrameMs(meanMs)
  };
}
